import { bgPrimary } from '@osmosis/tailwind-ui/styles/background';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { H3 } from '@osmosis/tailwind-ui/components/Text';
import React from 'react';

import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';

import { FormattedMessage } from 'react-intl';

import Image from 'next/legacy/image';
import threeCardImage from '../../../assets/three-card-videos.png';
import { PlaylistProps } from '@osmosis/shared/types/playlist';

type Props = {
  playlist: PlaylistProps;
  searchToggle: () => void;
};

/**
 * PlaylistEmpty.
 */
const PlaylistEmpty = (props: Props) => {
  const { playlist, searchToggle } = props;

  return (
    <Box data-testid="playlist-empty-container" className={`text-center p-8`}>
      <Image src={threeCardImage} alt="Card images" />
      <H3 className={`opacity-[0.75] my-4`}>
        <FormattedMessage
          defaultMessage="This playlist is empty."
          id="playlist.empty.playlist_empty"
        />
      </H3>
      <P className={`opacity-[0.75] mb-8`}>
        <FormattedMessage
          defaultMessage="Playlists you create or save to watch later will show up on the menu
            on the left."
          id="playlist.empty.playlist_tip"
        />
      </P>
      {playlist.userOwned && (
        <Button
          startIcon={<Icon icon={faPlus} />}
          onClick={searchToggle}
          data-testid="empty-playlist-toggle-search-btn"
          className={`${bgPrimary} mx-[auto]`}
          rounded={true}
        >
          <FormattedMessage
            defaultMessage="Add videos"
            id="playlist.empty.add_videos"
          />
        </Button>
      )}
    </Box>
  );
};

export default PlaylistEmpty;
